import React from 'react';
import merge from 'classnames';

import { ProgressSpinner } from '../ProgressSpinner';

import { Props } from './types';

import styles from './Button.module.scss';

export const Button = (props: Props) => {
  const {
    children,
    className,
    color,
    colorSchema,
    disabled,
    fakeDisabled,
    loading,
    loadingMessage,
    mobileFullWidth,
    onClick,
    onDisabledClick,
    ...buttonProps
  } = props;

  const clickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      event.preventDefault();

      return;
    }

    if (fakeDisabled) {
      event.preventDefault();
      onDisabledClick?.(event);

      return;
    }

    onClick?.(event);
  };

  return (
    <button
      type="button"
      {...buttonProps}
      className={merge(styles.button, styles[color], styles[colorSchema ?? ''], className, {
        [styles.disabled]: fakeDisabled,
        [styles.mobile_full_width]: mobileFullWidth,
      })}
      disabled={disabled}
      onClick={clickHandler}
    >
      {loading ? (
        <div className={styles.loading_content_wrapper}>
          <ProgressSpinner
            classes={{ container: styles.spinner_container, spinner: styles.spinner }}
            size={15}
          />
          {loadingMessage && <span>{loadingMessage}...</span>}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

Button.defaultProps = {
  className: '',
  color: 'transparent',
  colorSchema: '',
  disabled: false,
  mobileFullWidth: false,
  tabIndex: 0,
  type: 'button',
};
